import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Header from "../components/Header";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
// import required modules
import { EffectFade, Pagination, Navigation, Autoplay } from "swiper";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import i18n from "i18next";
import {
  banner_lists,
  banner_path,
  getHome_lists,
  home_path,
  rolesAssign_lists,
  rolesAssign_path,
  visionMision_lists,
} from "../redux/commonReducer";
import {
  ToggleStatus,
  getBanner,
  getBannerType,
  getHome,
  getRolesAssign,
  getVisionMission,
} from "../redux/actionCreator";
import { API_BASE_IMAGE_URL } from "../constants/configuration";
import Footer from "../components/Footer";
import Head from "../constants/Head";
import Fancybox from "../components/FancyBoxComponent";
import News from "./News";

function Home() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const ref = useRef()

  const [mobileBtnInci, setMobileBtnInci] = useState("");
  const [langToggle, setLangtoggle] = useState("");
  const [language, setLanguage] = useState("en");
  const [repoStatus, setRepoStatus] = useState(false)
  const [bannerType, setBannerType] = useState("image")

  const [headerheight, setheaderheight] = useState('')

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    setLanguage(lang);
  }, [localStorage.getItem("lang")]);

  // DATAS
  const BannerLists = useSelector(banner_lists);
  const visionMisionLists = useSelector(visionMision_lists);
  const getHomeLists = useSelector(getHome_lists);
  const rolesAssign = useSelector(rolesAssign_lists);
  const bannerPath = useSelector(banner_path);
  const homePath = useSelector(home_path);
  const rolesAssignPath = useSelector(rolesAssign_path);
  let current = localStorage.getItem("lang");

  useEffect(() => {
    dispatch(getBanner());
    dispatch(getBannerType(res => setBannerType(res)))
    dispatch(getVisionMission());
    dispatch(getRolesAssign());
    dispatch(getHome());
  }, []);

  useEffect(() => {
    const handleOrientationChange = () => {
      const match = window.matchMedia(`(max-width: 540px)`);
      setMobileBtnInci(match?.matches);
    };
    handleOrientationChange();
    window.addEventListener('orientationchange', handleOrientationChange);
    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
    };

  }, [setMobileBtnInci]);

  useEffect(() => {
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", "ar");
    }
    dispatch(ToggleStatus((status) => {
      setRepoStatus(status)
    }))
  }, []);

  useEffect(() => {
    const pathArray = location.pathname.split("/");
    if (pathArray?.length && pathArray?.includes("en")) {
      localStorage.setItem("lang", "en");
      setLanguage('en')
    } else {
      if (localStorage.getItem("lang")) {
        setLanguage(localStorage.getItem("lang"))
      } else {
        localStorage.setItem("lang", "ar");
        setLanguage('ar')
      }
    }

  }, [location.pathname])


  useEffect(() => {
    const path = location.pathname.includes("/en");
    // console.log(path);
    if (path) {
      localStorage.setItem("lang", "en");
    }

  }, []);

  useEffect(() => {
    setheaderheight(document.getElementById('navbarHeader').clientHeight)

  }, [])




  const chnageLan = (lang) => {
    setLangtoggle(!langToggle);
    localStorage.setItem("lang", lang);
    setLanguage(lang);

    if (lang === "ar") {
      document.body.className = "rtl";
    } else {
      document.body.className = "ltr";
    }
    let currentLanguage = lang == "en" ? "ar" : "en";
    // console.log(location.pathname.replace('/' + currentLanguage, '/' + lang));
    navigate(location.pathname.replace('/' + currentLanguage, '/' + lang));
    // if(location.pathname?.split("/")?.length === 1){
    //     navigate(`/en/`)
    // }else{
    //     navigate(`/${lang}/${location.pathname?.split("/")?.slice(-1)?.[0]}`)
    // }
  };

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {
    i18n.changeLanguage(current);
    if (current === "ar") {
      document.body.className = "rtl";
    } else {
      document.body.className = "ltr";
    }
  }, [current]);

  // console.log({ BannerLists })

  return (
    (
      <>
        {BannerLists?.length === 0 && <div id="preloader">
          <img src="./assets/img/loader.gif" alt="" />
        </div>}
        <Head
          title={t("html_title.home")}
          metatitle={t("html_title.home")}
          metaDescription={t("html_title.home")}
        />
        <Header />
        <section className="economic__banner">
          <div className="container sm-pad-0">
            {bannerType === "image" ?
              <div className="banner__slider">
                <Swiper
                  spaceBetween={30}
                  effect={"fade"}
                  pagination={{
                    clickable: true,
                  }}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  modules={[EffectFade, Autoplay, Pagination]}
                  className="mySwiper"
                >
                  {BannerLists?.filter(item => item.banner_type !== "video").map((ele, i) => {
                    return (
                      <SwiperSlide key={i}>
                        <div className="banner__contents">
                          <img src={API_BASE_IMAGE_URL + bannerPath + "/" + ele?.image_name} />
                          <h2>
                            {language == "en" ? ele?.title_en : ele?.title_ar}
                          </h2>
                          {
                            mobileBtnInci &&
                            <div className="incidentBtn_sm">
                              <Link to={`/${i18n.language}/report_incident`} rel="noreferrer">
                                <button className="report-incident" dir="ltr">
                                  <img src="./assets/img/icons/Group 11799.svg" />
                                  {t('report_incident')}
                                </button>
                              </Link>
                            </div>
                          }

                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
                <div className="vision__mission">
                  {visionMisionLists?.map((ele, i) => {
                    return (
                      <React.Fragment key={i}>
                        <div className="gridItem">
                          <h4>
                            {language == "en"
                              ? ele?.mission_title_en
                              : ele?.mission_title_ar}
                          </h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html:
                                language == "en"
                                  ? ele?.mission_detail_en
                                  : ele?.mission_detail_ar,
                            }}
                          ></p>
                        </div>
                        <div className="gridItem">
                          <h4>
                            {language == "en"
                              ? ele?.vision_title_en
                              : ele?.vision_title_ar}
                          </h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html:
                                language == "en"
                                  ? ele?.vision_detail_en
                                  : ele?.vision_detail_ar,
                            }}
                          ></p>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div> :
              <>
                {false && <div className="banner__slider">
                  {BannerLists?.filter(item => item.banner_type === "video").length &&
                    <div className="banner__contents">
                      <img src={API_BASE_IMAGE_URL + bannerPath + "/" + BannerLists.find(item => item.banner_type === "video")?.image_name} />
                      <h2>

                        <Fancybox
                          options={{
                            Carousel: {
                              infinite: false,
                            },
                          }}

                        >
                          <a rel="noreferrer" data-fancybox="gallery" href={language == "en" ? BannerLists?.find(item => item.banner_type === "video").video_url : (BannerLists?.find(item => item.banner_type === "video").video_url_ar ? BannerLists?.find(item => item.banner_type === "video").video_url_ar : BannerLists?.find(item => item.banner_type === "video").video_url)}>
                            <img src={API_BASE_IMAGE_URL + bannerPath + "/" + BannerLists?.find(item => item.banner_type === "video").thumb_image} height={320} />
                            {/* <div style={{backgroundImage: API_BASE_IMAGE_URL + bannerPath + "/" + BannerLists?.find(item => item.banner_type === "video").thumb_image, width: "100%", height: 320}}></div> */}
                            <img src="./assets/img/icons/play3.svg" className="play-icon" />
                          </a>
                        </Fancybox>
                      </h2>
                      {
                        mobileBtnInci &&
                        <div className="incidentBtn_sm">
                          <Link to={`/${i18n.language}/report_incident`} rel="noreferrer">
                            <button className="report-incident" dir="ltr">
                              <img src="./assets/img/icons/Group 11799.svg" />
                              {t('report_incident')}
                            </button>
                          </Link>
                        </div>
                      }

                    </div>}

                  <div className="vision__mission">

                    {BannerLists?.find(item => item.banner_type === "video") ? <>
                      <div className="gridItem">
                        <h1>
                          {language == "en" ? BannerLists?.find(item => item.banner_type === "video").title_en : BannerLists?.find(item => item.banner_type === "video").title_ar}
                        </h1>
                        <p
                          dangerouslySetInnerHTML={{
                            __html:
                              language == "en"
                                ? BannerLists?.find(item => item.banner_type === "video").desc?.slice(0, 400)
                                : BannerLists?.find(item => item.banner_type === "video").desc_ar,
                          }}
                        ></p>
                      </div>
                    </> : null}

                  </div>
                </div>}
                {true && <div dir={language === "en" ? "ltr" : "rtl"} className="banner__slider_video" style={{ backgroundImage: `url(${API_BASE_IMAGE_URL + bannerPath + "/" + BannerLists?.find(item => item.banner_type === "video")?.image_name})` }}>
                  {/* <img src={API_BASE_IMAGE_URL + bannerPath + "/" + BannerLists.find(item => item.banner_type === "video")?.image_name} style={{ position: "rela", }} /> */}
                  <div className="row mobile-row align-items-center" >
                    {/* <div className="col-sm-12 col-md-7"> */}
                    <Fancybox
                      options={{
                        Carousel: {
                          infinite: false,
                        },
                      }}
                      className="col-sm-12 col-md-6 col-lg-7 video-banner-image ps-0 pe-5"
                      container
                    >
                      <a rel="noreferrer" style={{ position: "relative" }} data-fancybox="gallery" href={language == "en" ? BannerLists?.find(item => item.banner_type === "video").video_url : (BannerLists?.find(item => item.banner_type === "video").video_url_ar ? BannerLists?.find(item => item.banner_type === "video").video_url_ar : BannerLists?.find(item => item.banner_type === "video").video_url)}>
                        <img className="vdo-img" src={API_BASE_IMAGE_URL + bannerPath + "/" + BannerLists?.find(item => item.banner_type === "video").thumb_image} width={"100%"} />
                        {/* <div style={{backgroundImage: API_BASE_IMAGE_URL + bannerPath + "/" + BannerLists?.find(item => item.banner_type === "video").thumb_image, width: "100%", height: 320}}></div> */}
                        <img src="./assets/img/icons/play3.svg" className="play-icon" />
                      </a>
                    </Fancybox>
                    {/* </div> */}
                    <div className="col-sm-12 col-md-6 col-lg-5">
                      {BannerLists?.find(item => item.banner_type === "video") ? <>
                        <div className="gridItem">
                          <h1 className="video-title">
                            {language == "en" ? BannerLists?.find(item => item.banner_type === "video").title_en : BannerLists?.find(item => item.banner_type === "video").title_ar}
                          </h1>
                          <p
                            dangerouslySetInnerHTML={{
                              __html:
                                language == "en"
                                  ? BannerLists?.find(item => item.banner_type === "video").desc?.slice(0, 400)
                                  : BannerLists?.find(item => item.banner_type === "video").desc_ar,
                            }}
                          ></p>

                          <div className="incidentBtn_sm position-relative mt-5 landscape__none">
                            <Link to={`/${i18n.language}/report_incident`} rel="noreferrer">
                              <button className="report-incident" dir="ltr">
                                <img src="./assets/img/icons/Group 11799.svg" />
                                {t('report_incident')}
                              </button>
                            </Link>
                          </div>
                        </div>

                      </> : null}
                    </div>
                  </div>
                </div>}

              </>}
          </div>
          <div className="container">
            <div className="roles__assignments">
              <div className="row bg-white">
                <div className="col-md-3 p-0 col-tab-4" style={{ backgroundColor: "#b98772" }}>
                  <Link
                    to={
                      language == "en"
                        ? `/en/about`
                        : `/ar/about`
                    }
                    rel="noreferrer"
                  >
                    <div className="about__Section">
                      <div className="icon">
                        <img
                          src={
                            API_BASE_IMAGE_URL + homePath + "/" + getHomeLists?.image_name
                          }
                          alt=""
                        />
                      </div>
                      <div className="contents">
                        <h5>
                          {language == "en"
                            ? getHomeLists?.title_en
                            : getHomeLists?.title_ar}
                        </h5>
                        <p
                          dangerouslySetInnerHTML={{
                            __html:
                              language == "en"
                                ? getHomeLists?.detail_en
                                : getHomeLists?.detail_ar,
                          }}
                        ></p>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-md-9 p-0 col-tab-8">
                  <div className="assigments__section">
                    <h3>{t("roles")}</h3>
                    <div className="navigation__default">
                      <i className="fas fa-arrow-left"></i>
                      <i className="fas fa-arrow-right"></i>
                    </div>
                    <Swiper
                      // spaceBetween={10}
                      modules={[Navigation]}
                      breakpoints={{
                        640: {
                          slidesPerView: 1,
                          spaceBetween: 20,
                        },
                        768: {
                          slidesPerView: 1,
                          spaceBetween: 40,
                        },
                        1024: {
                          slidesPerView: 2,
                          spaceBetween: 50,
                        },
                      }}
                      navigation={{
                        prevEl: ".fa-arrow-left",
                        nextEl: ".fa-arrow-right",
                      }}
                      className="mySwiper"
                    >
                      {rolesAssign?.map((ele, i) => {
                        return (
                          <SwiperSlide key={i}>
                            <Link
                              to={
                                language == "en"
                                  ? `/en/assignments/${ele?.title_slug_en}`
                                  : `/ar/assignments/${ele?.title_slug_ar}`
                              }
                              state={{ name: i }}
                              rel="noreferrer"
                            >
                              <div className="section__grids">
                                <div className="row">
                                  <div className="col-md-4 ">
                                    <div className="image">
                                      <img
                                        src={
                                          API_BASE_IMAGE_URL +
                                          rolesAssignPath + "/" +
                                          ele?.image_name
                                        }
                                        className="w-100"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-8">
                                    <div className="section__contents">
                                      <h5>
                                        {language == "en"
                                          ? ele?.title_en
                                          : ele?.title_ar}
                                      </h5>
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            language == "en"
                                              ? ele?.detail_en
                                              : ele?.detail_ar,
                                        }}
                                      ></p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container p-0">
            <News.Home />
          </div>

        </section>
        <Footer className='home' />
      </>
    )
  );
}

export default Home;
